import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ScheduledEmailsFormPresentation } from './scheduled-emails-form-presentation';
import { ScheduledEmailsFormManagement } from './scheduled-emails-form-management.viewmodel';
import './scheduled-emails-form.scss';

interface IProps {
    vm: ScheduledEmailsFormManagement;
}

const ScheduledEmailsFormContainer = withViewModel(
    ScheduledEmailsFormPresentation,
    (props: IProps) => {
        props.vm.fetchScheduledEmails();
        return props.vm;
    },
);

export { ScheduledEmailsFormContainer as ScheduledEmailsForm };